// extracted by mini-css-extract-plugin
export var animationContainer = "_nq-0";
export var footer = "_nq-1";
export var gray = "_nq-2";
export var lineItem = "_nq-3";
export var lineItemImage = "_nq-4";
export var lineItemInfo = "_nq-5";
export var lineItemText = "_nq-6";
export var lineItems = "_nq-7";
export var modalContent = "_nq-8";
export var options = "_nq-9";
export var orderName = "_nq-a";
export var refundAmount = "_nq-b";